export default __webpack_public_path__ + "static/media/10.9c4633b6.jpg";